import { Navigate, NavLink, useParams } from "react-router";
import { useFondByIdQuery, useUpdateFondMutation } from "../../stores/OkOkStore";
import UsersSelector from "../../components/Users/UsersSelector";
import  { type RefUser, roles } from "../../types/Users";
import { useEffect, useState } from "react";
import type { FondUpdate } from "../../types/Fond";
import { useTrads } from "../../contexts/trads/useTrads";

function FondOperators(){
    const params = useParams();
    const { data:fond, error, isLoading } = useFondByIdQuery(params.fondId??"0");
    const [updateFond,result]=useUpdateFondMutation();

    const [users, setUsers] = useState<RefUser[]>([]);
    const {translate}=useTrads();

    const submitHandler=function(){
        //x.operateurs=users;
        if(fond){
            const x:FondUpdate={id:fond.id,operateurs:users};
            void updateFond(x);
        }
    }

    useEffect(()=>{
        if(fond?.operateurs){
            setUsers(fond.operateurs);
        }
    },[fond,setUsers]);

    return (

      result.isSuccess ?<Navigate to={`/fond/${fond?.id.toString()?? "0"}`} state={{modified:"true"}}></Navigate>:(
      result.error ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p> :
      result.isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :

        error ? (
            <span><p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p></span>
        ) : isLoading ? (
            <span><p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p></span>
        ) : fond ? (
            
        <div>
            <nav>
                <ul className="nav nav-tabs">
                    <li className="nav-item"><NavLink className="nav-link" to={`/fond/${fond.id.toString()}/edit`}>{translate('btn_fond_edit')}</NavLink></li>
                    <li className="nav-item"><NavLink className="nav-link" to={`/fond/${fond.id.toString()}/operators`}>{translate('btn_fond_edit_operators')}</NavLink></li>
                    <li className="nav-item"><NavLink className="nav-link" to={`/fond/${fond.id.toString()}/beneficiaires`}>{translate('btn_fond_edit_beneficiaires')}</NavLink></li>
                </ul>
            </nav>

            <UsersSelector users={users} clickHandler={setUsers} filtre={{"r[rangacces]":roles.Operators}}></UsersSelector>
            <button onClick={submitHandler}>{translate('btn_save')}</button>
        </div>

            
        ):null
      )
    );
}
export default FondOperators;